import { Link } from "react-router-dom";
import React, { Component } from "react";
import "../../styles/css/ProjectCards/DetailCard.css";
import StarRateIcon from "@material-ui/icons/StarRate";
import StarRatingComponent from "react-star-rating-component";

const token = localStorage.getItem("token");
const userRole = localStorage.getItem("userRole");

class DetailCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardData: {},
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.cardData !== prevProps.cardData) {
      this.setState({ cardData: this.props.cardData });
    }
  }

  render() {
    const { jobId, cardData, bidStartedDate } = this.props;

    return (
      <div className="detailCardRoot">
        <div className="detailCardMain">
          <div className="detailCardTitle">
            <div className="nameMain">
              <span>Details</span>
            </div>
          </div>
          <div className="detailCardDetails">
            {token && token.length > 0 ? (
              userRole === "Title Company Admin" ||
              userRole === "Title Company User" ||
              userRole === "Admin" ? (
                jobId !== "0" ? (
                  <div>
                    <hr />
                    <div className="cardDetail">
                      <span>Job ID</span>
                      <span className="rightAlign">{cardData.job_id}</span>
                    </div>
                    <div className="cardDetail">
                      <span>Status</span>
                      <span className="rightAlign">{cardData.status}</span>
                    </div>
                    <hr />
                    <div className="cardDetail">
                      <span>Created on</span>
                      <span className="rightAlign">
                        {"created_on" in cardData &&
                          cardData.created_on.date.split(" ")[0]}
                      </span>
                    </div>
                    {"posted_on" in cardData && (
                      <div className="cardDetail">
                        <span>Posted on</span>
                        <span className="rightAlign">
                          {"posted_on" in cardData &&
                            cardData.posted_on.split(" ")[0]}
                        </span>
                      </div>
                    )}
                    {bidStartedDate !== 0 &&
                      cardData.status !== "Created" &&
                      cardData.status !== "Posted" && (
                        <div className="cardDetail">
                          <span>Started on</span>
                          <span className="rightAlign">{bidStartedDate}</span>
                        </div>
                      )}
                  </div>
                ) : (
                  <div>
                    <hr />
                    <div className="cardDetail">
                      <span>Status</span>
                      <span className="rightAlign">Not created</span>
                    </div>
                  </div>
                )
              ) : userRole === "Surveyor" || userRole === "Admin" ? (
                <div>
                  <hr />
                  <div className="cardDetail">
                    <span>Job ID</span>
                    <span className="rightAlign">{cardData.job_id}</span>
                  </div>
                  <div className="cardDetail">
                    <span>Status</span>
                    <span className="rightAlign">{cardData.status}</span>
                  </div>
                  <hr />
                  <div className="cardDetail">
                    <span>Created on</span>
                    <span className="rightAlign">
                      {"created_on" in cardData &&
                        cardData.created_on.date.split(" ")[0]}
                    </span>
                  </div>
                  <div className="cardDetail">
                    <span>Posted on</span>
                    <span className="rightAlign">
                      {"posted_on" in cardData &&
                        cardData.posted_on.split(" ")[0]}
                    </span>
                  </div>
                  {bidStartedDate &&
                    cardData.status !== "Created" &&
                    cardData.status !== "Posted" && (
                      <div className="cardDetail">
                        <span>Started on</span>
                        <span className="rightAlign">{bidStartedDate}</span>
                      </div>
                    )}
                  <div className="cardDetail">
                    <span>Company name</span>
                    <Link to={"/Profile/" + cardData.company_id}>
                      <span className="rightAlign bidCardNameLink">
                        {cardData.company_name}
                      </span>
                    </Link>
                  </div>
                  <div className="cardDetail">
                    <span>Company rating</span>
                    <span className="rightAlign">
                      <StarRatingComponent
                        name="rate1"
                        starCount={5}
                        value={Math.round(cardData.company_rating, 10)}
                        starColor={"#9cd5f1"}
                        emptyStarColor={"#b1b1b1"}
                        renderStarIcon={() => (
                          <StarRateIcon style={{ width: "20px" }} />
                        )}
                        editing={false}
                      />
                    </span>
                  </div>
                </div>
              ) : null
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default DetailCard;



// WEBPACK FOOTER //
// ./src/pages/Jobs/JobDetailsCard.js